module.exports = __webpack_public_path__ + "img/4.596344c7.jpg";